import cn from "classnames";
import {
  eachYearOfInterval,
  format,
  getYear,
  isSameYear,
  setYear,
} from "date-fns";


import { Text } from "@/components/Text";

import styles from "./CalendarYears.module.scss";

interface CalendarYearsProps {
  currentDate: Date;
  onYearChange: (year: number) => void;
}

export const CalendarYears = ({
  currentDate,
  onYearChange,
}: CalendarYearsProps): React.JSX.Element | null => {
  const years = eachYearOfInterval({
    start: setYear(currentDate, Math.floor(getYear(currentDate) / 10) * 10),
    end: setYear(currentDate, Math.floor(getYear(currentDate) / 10) * 10 + 11),
  });

  const getYearClasses = (year: Date) => {
    return cn(styles.year, {
      [styles.today]: isSameYear(year, new Date()),
      [styles["same-year"]]: isSameYear(year, currentDate),
    });
  };

  return (
    <div className={styles["container"]}>
      {years.map((date) => (
        <div
          key={getYear(date)}
          className={getYearClasses(date)}
          onClick={() => onYearChange(getYear(date))}
        >
          <Text variant="text-2-medium">{format(date, "yyyy")}</Text>
        </div>
      ))}
    </div>
  );
};
